import { px } from "csx";
import { FC } from "react";
import AngleDownIcon from "shared/assets/icons/angle-down.svg?react";
import AngleUpIcon from "shared/assets/icons/angle-up.svg?react";
import CageIcon from "shared/assets/icons/cage.svg?react";
import CloseIcon from "shared/assets/icons/close.svg?react";
import FishIcon from "shared/assets/icons/fish.svg?react";
import LogoutIcon from "shared/assets/icons/logout.svg?react";
import MapIcon from "shared/assets/icons/map.svg?react";
import PauseIcon from "shared/assets/icons/pause.svg?react";
import PelletsIcon from "shared/assets/icons/pellets.svg?react";
import SiteIcon from "shared/assets/icons/site.svg?react";
import SquareIcon from "shared/assets/icons/square.svg?react";
import UserIcon from "shared/assets/icons/user.svg?react";
import { classes, style, stylesheet } from "typestyle";

const icons = {
  map: MapIcon,
  angleUp: AngleUpIcon,
  angleDown: AngleDownIcon,
  site: SiteIcon,
  cage: CageIcon,
  user: UserIcon,
  logout: LogoutIcon,
  pause: PauseIcon,
  square: SquareIcon,
  close: CloseIcon,
  pellets: PelletsIcon,
  fish: FishIcon,
};

export type AppIcons = keyof typeof icons;

interface IconProps {
  icon: AppIcons;
  fill?: string;
  className?: string;
  size?: "small" | "medium" | "large";
  onClick?: React.MouseEventHandler<SVGSVGElement>;
}

export const Icon: FC<IconProps> = ({
  icon,
  fill,
  size = "medium",
  className,
  onClick,
}) => {
  const IconComponent = icons[icon];

  const iconStyle = style({
    fill: fill || "currentColor",
    $nest: {
      "& *": {
        fill: `${fill || "currentColor"} !important`,
      },
    },
  });

  return (
    <IconComponent
      data-testid="button-icon"
      onClick={onClick}
      className={classes(sizes[size], iconStyle, className)}
    />
  );
};

const sizes = stylesheet({
  small: {
    width: px(15),
  },
  medium: {
    width: px(18),
  },
  large: {
    width: px(22),
  },
});
